<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">Eventos de Auditoria</h1>

  @if (error) {
  <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <!-- Filters Form -->
  <form (ngSubmit)="onSearch()" class="p-3 mb-4 pt-4 rounded dark:bg-neutral-900 dark:text-white" [class.flex]="version === 'v2'">
    <div class="grid grid-cols-1 md:grid-cols-5 gap-4 w-full">
      @if (version === 'v1') {
      <div>
        <label class="block text-sm mb-1">Ação</label>
        <input
          [(ngModel)]="uiFilters.actionName"
          name="actionName"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        />
      </div>
      }
      <div>
        <label class="block text-sm mb-1">Usuário</label>
        <input
          [(ngModel)]="uiFilters.userName"
          name="userName"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        />
      </div>
      @if (version === 'v1') {
      <div>
        <label class="block text-sm mb-1">Email</label>
        <input
          [(ngModel)]="uiFilters.email"
          name="email"
          type="text"
          class="w-full px-3 py-2 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        />
      </div>
      }
      <div>
        <label class="block text-sm mb-1">Início</label>
        <input
          [(ngModel)]="uiFilters.startDate"
          name="startDate"
          type="datetime-local"
          class="w-full px-3 py-2 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        />
      </div>
      <div>
        <label class="block text-sm mb-1">Fim</label>
        <input
          [(ngModel)]="uiFilters.endDate"
          name="endDate"
          type="datetime-local"
          class="w-full px-3 py-2 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        />
      </div>
      <div>
        <label class="block text-sm mb-1">Sucesso</label>
        <select
          [(ngModel)]="uiFilters.success"
          name="success"
          class="px-3 py-2 h-11 dark:bg-neutral-800 border rounded-md bg-white text-black dark:text-white"
        >
          <option value="">Todos</option>
          <option value="true">Sim</option>
          <option value="false">Não</option>
        </select>
      </div>
    </div>
    <div class="mt-4 flex gap-2">
      <app-button type="submit">Buscar</app-button>
      <app-button type="button" (click)="onClear()">Limpar</app-button>
    </div>
  </form>

  <div class="overflow-x-auto mt-2">
    <table class="table-auto w-full border-collapse border border-slate-400">
      <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">ID</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Ação</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Usuário</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Início</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Duração</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">Sucesso</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
      </thead>
      <tbody>
        @for (e of events; track e.id; let even = $even) {
        <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ e.id }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ auditFriendlyName(e.actionName) }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ e.userName }}</td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ e.startTime | date : 'yyyy-MM-dd HH:mm:ss' }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ formatElapsed(e.elapsedSeconds) }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            {{ e.success ? 'Sim' : 'Não' }}
          </td>
          <td class="border border-neutral-300 dark:border-neutral-600 p-2">
            <a
              class="flex items-center justify-center underline"
              [routerLink]="['/audit/event', e.id]"
            >
              <i
                class="btn rounded-md flex items-center justify-center gap-2 bg-white border-black hover:bg-black hover:text-white dark:bg-black dark:border-white dark:hover:bg-white dark:hover:text-black py-1 px-3 text-sm"
                [innerHTML]="'eye' | feather : { width: 16, height: 16 }"
              ></i>
            </a>
          </td>
        </tr>
        } @empty {
        <tr class="bg-neutral-50 dark:bg-neutral-800">
          <td colspan="8">
            @if (paginationState().loading) {
            <app-loading size="large" color="primary" />
            } @else {
            {{ 'PAGINATION.NO_ITEMS' | translate }}
            }
          </td>
        </tr>
        }
      </tbody>
    </table>

    <app-pagination
      [paginationState]="paginationState()"
      [onPaginationChange]="onPageChange"
    ></app-pagination>
  </div>
</div>
